define( function() {
	"use strict";

	return window.location;
} );



//////////////////
// WEBPACK FOOTER
// /srv/_versions/easypost-web/easypost-web-201706012359-95877d6b9a-master/~/jquery/src/ajax/var/location.js
// module id = 939
// module chunks = 1